var React = require('react');

function SocialYoutube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M51 23.9c0-3.8 0-7.9-.9-11.7-.3-1.4-1.1-2.6-2.1-3.6-1-.9-2.3-1.5-3.7-1.7-3.1-.3-6.1-.5-9.2-.6-3.1-.1-6.2-.1-9.3-.1-3.1 0-6.2 0-9.3.1-3 .2-6.1.3-9.2.7-1.4.1-2.7.7-3.7 1.7-1 .9-1.8 2.1-2.1 3.6-.4 1.9-.7 3.9-.8 5.9-.1 2-.1 4-.1 5.9 0 1.9 0 3.9.1 5.9.1 2 .3 4 .8 5.9.3 1.4 1.1 2.6 2.1 3.6 1 .9 2.3 1.5 3.7 1.7 3.1.3 6.2.5 9.3.6 3.1.1 6.2.1 9.3.1 3.1 0 6.2 0 9.3-.1 3.1-.1 6.2-.3 9.2-.6 1.4-.2 2.7-.8 3.7-1.7 1-.9 1.8-2.1 2.1-3.6.4-1.9.7-3.9.8-5.9v-6.1zm-15.6.1l-7.8 4c-2.6 1.4-5.2 2.7-7.8 4.1l-.8.4V14.4l.8.4c2.4 1.2 4.7 2.5 7.1 3.7 2.8 1.5 5.7 3 8.6 4.5l.9.5-1 .5z"}));
}

SocialYoutube.defaultProps = {"fill":"currentColor","viewBox":"0 0 51.6 48.3"};

module.exports = SocialYoutube;

SocialYoutube.default = SocialYoutube;
